export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Tipo de plan\",\n    \"label_plural\": \"{{count}} tipos de plan\"\n}\n"